export default __webpack_public_path__ + "static/gatsby_TOC_items-8b4cfaa31fff92fcfd0f0d1e7eca66bf.png";